import { ReactNode } from "react";
import { useRouteParams } from "src/hooks/useRouteParams";
import { PlanEditorHeader } from "src/routes/components/PlanConfiguration/PlanEditorHeader";
import { usePlanPackageEditorHeaderQuery } from "src/routes/libraries/plan-package/stepper/components/PlanPackageEditorHeader.generated";
import { PlanPackageDetailsParams } from "src/routes/routesDef";
import { createPlanPackageUrl, createPlanPackagesUrl } from "src/RouteUrls";

type PlanPackageEditorHeaderProps = { title: ReactNode; subtitle?: ReactNode; tooltip?: ReactNode; right?: ReactNode };

export function PlanPackageEditorHeader({ title, subtitle, tooltip, right }: PlanPackageEditorHeaderProps) {
  const { planPackageId, planPackageVersionId } = useRouteParams<PlanPackageDetailsParams>();
  const { data } = usePlanPackageEditorHeaderQuery({
    variables: { id: planPackageId },
    skip: !planPackageId,
    fetchPolicy: "cache-first",
  });
  const planName = data?.planPackage.name;

  return (
    <PlanEditorHeader
      title={title}
      subtitle={subtitle}
      tooltip={tooltip}
      right={right}
      backUrl={planPackageId ? createPlanPackageUrl(planPackageId, planPackageVersionId) : createPlanPackagesUrl()}
      breadcrumbs={[
        { href: createPlanPackagesUrl(), text: "Plans" },
        { text: planName ? `Editing '${planName}'` : "Create New Plan Package" },
      ]}
    />
  );
}
